import React, { useRef } from 'react';
import './App.css';
import BibleReader, { BibleReaderRef } from './components/BibleReader';

function App() {
  const bibleReaderRef = useRef<BibleReaderRef>(null);

  const handleGoHome = () => {
    if (bibleReaderRef.current) {
      bibleReaderRef.current.handleBackToBooks();
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1 
          onClick={handleGoHome}
          style={{ cursor: 'pointer' }}
        >
          Let’s read the Bible aloud
        </h1>
      </header>
      <main>
        <BibleReader ref={bibleReaderRef} />
      </main>
    </div>
  );
}

export default App;
